<template>
  <div class="relative">
    <div class="relative">
      <div class="absolute eye-wrapper" v-if="type == 'password'">
        <div class="eye-container" @click="togglePassword">
          <img src="@/assets/images/view-password.svg" v-if="changeInputToText" alt=""> 
          <svg
            v-else
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.1621 14.4413C10.7806 14.4826 10.393 14.5062 10 14.5121C8.28292 14.5045 6.50295 14.0868 4.81812 13.2865C3.56715 12.6678 2.34857 11.7944 1.29028 10.7169C0.770533 10.1669 0.107183 9.37058 0 8.52091C0.0126667 7.78488 0.80255 6.87641 1.29028 6.32484C2.28267 5.28974 3.46952 4.44129 4.81812 3.75528C4.86395 3.73303 4.90995 3.71104 4.95605 3.68936L3.70485 1.50433L5.40493 0.499559L14.5952 16.5001L12.9588 17.5002L11.1621 14.4413ZM15.0427 13.35L13.7939 11.1857C14.3684 10.4393 14.7095 9.51894 14.7095 8.52091C14.7095 6.03329 12.6008 4.01651 9.99877 4.01651C9.88628 4.01651 9.77727 4.02864 9.66673 4.03604L8.84032 2.60538C9.22145 2.56456 9.60682 2.53483 9.99998 2.52969C11.7187 2.53741 13.4977 2.95989 15.1807 3.75528C16.4316 4.37398 17.6514 5.24743 18.7097 6.32484C19.2295 6.87483 19.8928 7.67121 20 8.52091C19.9873 9.25693 19.1974 10.1654 18.7097 10.717C17.7173 11.7521 16.5293 12.6005 15.1807 13.2865C15.1351 13.3086 15.0885 13.3285 15.0427 13.35ZM9.99878 13.0253C10.1129 13.0253 10.2261 13.0207 10.3381 13.0131L9.37012 11.3371C8.01155 11.0616 6.99218 9.90573 6.99218 8.52211C6.99218 8.17454 7.0562 7.84179 7.17407 7.53336C7.1742 7.53301 7.17393 7.53248 7.17407 7.53213L6.2036 5.85123C5.62775 6.59828 5.28807 7.52171 5.28807 8.52093C5.28808 11.0085 7.3968 13.0253 9.99878 13.0253ZM12.8149 9.49136L10.6336 5.71206C11.9848 5.99268 12.9968 7.14331 12.9968 8.52211C12.9968 8.86334 12.9287 9.18776 12.8149 9.49136Z"
              fill="#10233E"
            />
          </svg>
        </div>
      </div>
      <div
        class="flex items-center input-wrapper"
        :class="[error ? 'error-border' : null]"
      >
        <div v-if="$slots.icon">
          <slot name="icon"></slot>
        </div>
        <input
          class="input"
          :class="[p, width ? width : 'w-full']"
          :type="inputType"
          :name="name"
          :id="id"
          :value="value"
          @keypress="isNumber($event)"
          @input="$emit('input', $event.target.value)"
          @blur="validateInput"
          @focus="resetInput"
          @change="$emit('change')"
          autocomplete="on"
          :placeholder="placeholder"
          :disabled="disabled"
          :required="required"
          :autofocus="autofocus"
        />
        <div v-if="$slots['icon-right']">
          <slot name="icon-right"></slot>
        </div>
      </div>
    </div>

    <div class="error-text text-center -mt-2">
      <transition name="fade">
        <p class="text-red-600 text-left text-lg text-xs" v-if="error">
          {{ errorText }}
        </p>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "type",
    "name",
    "p",
    "value",
    "id",
    "placeholder",
    "disabled",
    "errorText",
    "validation",
    "required",
    "revealPassword",
    "autofocus",
    "width",
  ],
  data() {
    return {
      show: false,
      error: false,
      showEye: true,
      showEyeWrapper: false,
      eyeDropper: false,
      changeInputToText: false,
    };
  },
  computed: {
    inputType() {
      return this.changeInputToText ? "text" : this.type;
    },
  },
  methods: {
    togglePassword() {
      this.changeInputToText = !this.changeInputToText;
    },
    validateInput() {
      if (this.validation == undefined) {
        return;
      }
      if (this.validation) {
        this.error = false;
        this.$emit("valid");
      } else {
        this.error = true;
        this.$emit("invalid");
      }
    },
    resetInput() {
      this.error = false;
    },
    isNumber: function(evt) {
      if (this.type === "number") {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
          (charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            charCode !== 46) ||
          this.amount > 1000000
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
    },
  },
};
</script>
<style scoped>
.eye-wrapper {
  right: 1rem;
  top: 35%;
  cursor: pointer;
}

.eye-container {
  position: relative;
}
.line-stroke {
  position: absolute;
  height: 2rem;
  width: 0.15rem;
  background-color: #b5b5b5;
  top: -0.35rem;
  transform: rotate(-45deg);
  left: 50%;
}
.error-border {
  border: 1px solid #f46f64;
}
.error-text {
  top: 3.5rem;
  left: 0;
  width: 100%;
}
.input-wrapper {
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  height: 2.65rem;
  padding: 0 0.5rem;
  margin-bottom: 1rem;
}
.input {
  display: initial;
  background: transparent;
  border: none;
  box-sizing: border-box;
  width: 100%;
  height: 2.65rem;
  padding: 0 0.5rem;
  margin-bottom: 0;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  background: transparent;
}

@media only screen and (max-width: 768px) {
  .error-text {
    top: 2.5rem;
  }
}
.error-image {
  right: 1rem;
  top: 35%;
  z-index: 2;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s cubic-bezier(0.45, 0.25, 0.6, 0.95);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
